export default __webpack_public_path__ + "static/media/PartOfOurStoryLogo2.d8ba1dc0.webp";